<template>
	<el-card>
		<div slot="header" class="flex-align-center">
			<el-button type="danger" @click="deleteChange(sels)" :disabled="this.sels.length === 0">批量删除</el-button>
			<el-input style="margin: 0 20px;" v-model="postKeyword" placeholder="按帖子内容查找"><i slot="prefix" class="el-input__icon el-icon-search"></i></el-input>
			<el-input style="margin-right: 20px;" v-model="userKeyword" placeholder="按用户昵称查找"><i slot="prefix" class="el-input__icon el-icon-search"></i></el-input>
			<el-input style="margin-right: 20px;" v-model="topicKeyword" placeholder="按圈子名称查找"><i slot="prefix" class="el-input__icon el-icon-search"></i></el-input>
			<el-select v-model="order" clearable placeholder="排序" style="margin-right: 20px;width: 500px;">
				<el-option v-for="(item, index) in postOrder" :key="index" :label="item.label" :value="item.value"></el-option>
			</el-select>
			<el-button @click="getPostList" class="search-btn" type="primary">查找</el-button>
		</div>
		<el-table v-loading="loading" ref="multipleTable" :data="postList" tooltip-effect="dark" @selection-change="selsChange">
			<el-table-column type="selection" width="55"></el-table-column>
			<!-- 复选框 -->
			<el-table-column prop="id" label="ID" width="100"></el-table-column>
			<el-table-column label="用户" width="150">
				<template slot-scope="scope">
					<div class="flex-align-center">
						<el-avatar :size="30" :src="scope.row.userInfo.avatar"></el-avatar>
						<span style="margin-left: 10px;flex: 1;">{{ scope.row.userInfo.username }}</span>
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="content" label="内容" show-overflow-tooltip></el-table-column>
			<el-table-column label="媒体">
				<template slot-scope="scope">
					<div class="post-img-box">
						<img v-if="scope.row.type === 1" v-for="(item, index) in scope.row.media" :key="index" :src="item" />
						<video controls="controls" v-if="scope.row.type === 2" v-for="(item, index) in scope.row.media" :key="index" :src="item"></video>
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="read_count" label="浏览量" align="center"></el-table-column>
			<el-table-column prop="create_time" :formatter="$f.timeFormat" label="发布时间"></el-table-column>
			<el-table-column label="管理" width="100">
				<template slot-scope="scope">
					<!-- <el-button>编辑</el-button> -->
					<el-popconfirm
						style="margin-left: 5px;"
						confirmButtonText="确定"
						cancelButtonText="取消"
						@confirm="postDel(scope.row.id, scope.$index)"
						icon="el-icon-info"
						iconColor="red"
						title="确定删除？"
					>
						<el-button slot="reference" type="danger">删除</el-button>
					</el-popconfirm>
				</template>
			</el-table-column>
		</el-table>
		<el-pagination @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pagesize" layout="total,prev,pager,next" :total="postLength"></el-pagination>
	</el-card>
</template>

<script>
export default {
	data() {
		return {
			sels: [], //选中的值显示
			currentPage: 1,
			pagesize: 0,
			postList: [],
			postLength: 0,
			postOrder: [
				{
					value: 'id desc',
					label: '发布时间'
				},
				{
					value: 'read_count desc',
					label: '浏览量'
				}
			],
			postKeyword:'',
			userKeyword:'',
			topicKeyword:'',
			order:'',
			loading:false
		};
	},
	created() {
		this.getPostList();
	},
	methods: {
		getPostList() {
			this.loading = true
			this.$H
				.get('post/list', {
					page: this.currentPage,
					order:this.order,
					post_keyword:this.postKeyword,
					user_keyword:this.userKeyword,
					topic_keyword:this.topicKeyword
				})
				.then(res => {
					this.postList = res.result.data;
					this.pagesize = res.result.per_page;
					this.postLength = res.result.total;
					this.loading = false
				});
		},
		handleCurrentChange(currentPage) {
			this.currentPage = currentPage;
			this.getPostList();
		},
		postDel(id, index) {
			this.$H
				.post('post/del', {
					id: id
				})
				.then(res => {
					if (res.code == 200) {
						this.postList.splice(index, 1);
						this.$message.success('删除成功');
					}
				});
		},
		selsChange(sels) {
			this.sels = sels;
		},
		deleteChange(index) {
			var ids = this.sels.map(item => item.id).join(); //获取所有选中行的id组成的字符串，以逗号分隔
			console.log(ids);
			this.$confirm('此操作将永久删除选中数据, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(() => {
					this.$H
						.post('post/Changedel', {
							id: ids
						})
						.then(res => {
							if (res.code == 200) {
								this.$message.success('删除成功');
								setTimeout(() => {
									location.reload();
								}, 1000);
							}
						});
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
		}
	}
};
</script>

<style scoped="scoped">
.post-img-box {
	display: flex;
}

.post-img-box > img {
	width: 100px;
	height: 100px;
	margin-right: 5px;
	margin-bottom: 5px;
}

.post-img-box > video {
	width: 100px;
	height: 100px;
	margin-right: 5px;
	margin-bottom: 5px;
}
</style>
